const actions = {
  // start: role
  FETCH_ROLE_DATA: 'FETCH_ROLE_DATA',
  FETCHING_ROLE_DATA: 'FETCHING_ROLE_DATA',
  FETCH_ROLE_DATA_SUCCESS: 'FETCH_ROLE_DATA_SUCCESS',
  FETCH_ROLE_DATA_FAILED: 'FETCH_ROLE_DATA_FAILED',

  FETCH_ROLE_DATA_BY_ID: 'FETCH_ROLE_DATA_BY_ID',
  FETCHING_ROLE_DATA_BY_ID: 'FETCHING_ROLE_DATA_BY_ID',
  FETCH_ROLE_DATA_BY_ID_SUCCESS: 'FETCH_ROLE_DATA_BY_ID_SUCCESS',
  FETCH_ROLE_DATA_BY_ID_FAILED: 'FETCH_ROLE_DATA_BY_ID_FAILED',

  ADD_ROLE_DATA: 'ADD_ROLE_DATA',
  ADDING_ROLE_DATA: 'ADDING_ROLE_DATA',
  ADD_ROLE_DATA_SUCCESS: 'ADD_ROLE_DATA_SUCCESS',
  ADD_ROLE_DATA_FAILED: 'ADD_ROLE_DATA_FAILED',

  EDIT_ROLE_DATA: 'EDIT_ROLE_DATA',
  EDITING_ROLE_DATA: 'EDITING_ROLE_DATA',
  EDIT_ROLE_DATA_SUCCESS: 'EDIT_ROLE_DATA_SUCCESS',
  EDIT_ROLE_DATA_FAILED: 'EDIT_ROLE_DATA_FAILED',

  DELETE_ROLE_DATA: 'DELETE_ROLE_DATA',
  DELETING_ROLE_DATA: 'DELETING_ROLE_DATA',
  DELETE_ROLE_DATA_SUCCESS: 'DELETE_ROLE_DATA_SUCCESS',
  DELETE_ROLE_DATA_FAILED: 'DELETE_ROLE_DATA_FAILED',
  // end: role

  // start: industry
  FETCH_INDUSTRY_DATA: 'FETCH_INDUSTRY_DATA',
  FETCHING_INDUSTRY_DATA: 'FETCHING_INDUSTRY_DATA',
  FETCH_INDUSTRY_DATA_SUCCESS: 'FETCH_INDUSTRY_DATA_SUCCESS',
  FETCH_INDUSTRY_DATA_FAILED: 'FETCH_INDUSTRY_DATA_FAILED',

  ADD_INDUSTRY_DATA: 'ADD_INDUSTRY_DATA',
  ADDING_INDUSTRY_DATA: 'ADDING_INDUSTRY_DATA',
  ADD_INDUSTRY_DATA_SUCCESS: 'ADD_INDUSTRY_DATA_SUCCESS',
  ADD_INDUSTRY_DATA_FAILED: 'ADD_INDUSTRY_DATA_FAILED',

  EDIT_INDUSTRY_DATA: 'EDIT_INDUSTRY_DATA',
  EDITING_INDUSTRY_DATA: 'EDITING_INDUSTRY_DATA',
  EDIT_INDUSTRY_DATA_SUCCESS: 'EDIT_INDUSTRY_DATA_SUCCESS',
  EDIT_INDUSTRY_DATA_FAILED: 'EDIT_INDUSTRY_DATA_FAILED',

  CHANGE_STATUS_INDUSTRY_DATA: 'CHANGE_STATUS_INDUSTRY_DATA',
  CHANGING_STATUS_INDUSTRY_DATA: 'CHANGING_STATUS_INDUSTRY_DATA',
  CHANGE_STATUS_INDUSTRY_DATA_SUCCESS: 'CHANGE_STATUS_INDUSTRY_DATA_SUCCESS',
  CHANGE_STATUS_INDUSTRY_DATA_FAILED: 'CHANGE_STATUS_INDUSTRY_DATA_FAILED',
  // end: industry

  // start: address
  FETCH_ADDRESSES_DATA: 'FETCH_ADDRESSES_DATA',
  FETCHING_ADDRESSES_DATA: 'FETCHING_ADDRESSES_DATA',
  FETCH_ADDRESSES_DATA_SUCCESS: 'FETCH_ADDRESSES_DATA_SUCCESS',
  FETCH_ADDRESSES_DATA_FAILED: 'FETCH_ADDRESSES_DATA_FAILED',

  ADD_ADDRESS_DATA: 'ADD_ADDRESS_DATA',
  ADDING_ADDRESS_DATA: 'ADDING_ADDRESS_DATA',
  ADD_ADDRESS_DATA_SUCCESS: 'ADD_ADDRESS_DATA_SUCCESS',
  ADD_ADDRESS_DATA_FAILED: 'ADD_ADDRESS_DATA_FAILED',

  ADD_OTP_SERVICE_DATA: 'ADD_OTP_SERVICE_DATA',
  ADDING_OTP_SERVICE_DATA: 'ADDING_OTP_SERVICE_DATA',
  ADD_OTP_SERVICE_DATA_SUCCESS: 'ADD_OTP_SERVICE_DATA_SUCCESS',
  ADD_OTP_SERVICE_DATA_FAILED: 'ADD_OTP_SERVICE_DATA_FAILED',

  ADD_OTP_SERVICE_TEMPLATE_DATA: 'ADD_OTP_SERVICE_TEMPLATE_DATA',
  ADDING_OTP_SERVICE_TEMPLATE_DATA: 'ADDING_OTP_SERVICE_TEMPLATE_DATA',
  ADD_OTP_SERVICE_TEMPLATE_DATA_SUCCESS: 'ADD_OTP_SERVICE_TEMPLATE_DATA_SUCCESS',
  ADD_OTP_SERVICE_TEMPLATE_DATA_FAILED: 'ADD_OTP_SERVICE_TEMPLATE_DATA_FAILED',

  TEST_GENERATE_OTP: 'TEST_GENERATE_OTP',
  TESTING_GENERATE_OTP: 'TESTING_GENERATE_OTP',
  TEST_GENERATE_OTP_SUCCESS: 'TEST_GENERATE_OTP_SUCCESS',
  TEST_GENERATE_OTP_FAILED: 'TEST_GENERATE_OTP_FAILED',
  RESET_TEST_GENERATE_OTP: 'RESET_TEST_GENERATE_OTP',

  FETCH_OTP_SERVICE_TEMPLATE_DATA: 'FETCH_OTP_SERVICE_TEMPLATE_DATA',
  FETCHING_OTP_SERVICE_TEMPLATE_DATA: 'FETCHING_OTP_SERVICE_TEMPLATE_DATA',
  FETCH_OTP_SERVICE_TEMPLATE_DATA_SUCCESS: 'FETCH_OTP_SERVICE_TEMPLATE_DATA_SUCCESS',
  FETCH_OTP_SERVICE_TEMPLATE_DATA_FAILED: 'FETCH_OTP_SERVICE_TEMPLATE_DATA_FAILED',

  ADD_PROVINCE_DATA: 'ADD_PROVINCE_DATA',
  ADDING_PROVINCE_DATA: 'ADDING_PROVINCE_DATA',
  ADD_PROVINCE_DATA_SUCCESS: 'ADD_PROVINCE_DATA_SUCCESS',
  ADD_PROVINCE_DATA_FAILED: 'ADD_PROVINCE_DATA_FAILED',

  EDIT_ADDRESS_DATA: 'EDIT_ADDRESS_DATA',
  EDITING_ADDRESS_DATA: 'EDITING_ADDRESS_DATA',
  EDIT_ADDRESS_DATA_SUCCESS: 'EDIT_ADDRESS_DATA_SUCCESS',
  EDIT_ADDRESS_DATA_FAILED: 'EDIT_ADDRESS_DATA_FAILED',

  EDIT_OTP_SETTINGS_DATA: 'EDIT_OTP_SETTINGS_DATA',
  EDITING_OTP_SETTINGS_DATA: 'EDITING_OTP_SETTINGS_DATA',
  EDIT_OTP_SETTINGS_DATA_SUCCESS: 'EDIT_OTP_SETTINGS_DATA_SUCCESS',
  EDIT_OTP_SETTINGS_DATA_FAILED: 'EDIT_OTP_SETTINGS_DATA_FAILED',

  EDIT_OTP_SETTINGS_TEMPLATE_DATA: 'EDIT_OTP_SETTINGS_TEMPLATE_DATA',
  EDITING_OTP_SETTINGS_TEMPLATE_DATA: 'EDITING_OTP_SETTINGS_TEMPLATE_DATA',
  EDIT_OTP_SETTINGS_TEMPLATE_DATA_SUCCESS: 'EDIT_OTP_SETTINGS_TEMPLATE_DATA_SUCCESS',
  EDIT_OTP_SETTINGS_TEMPLATE_DATA_FAILED: 'EDIT_OTP_SETTINGS_TEMPLATE_DATA_FAILED',

  GENERATE_NEW_OTP_KEY_DATA: 'GENERATE_NEW_OTP_KEY_DATA',
  GENERATING_NEW_OTP_KEY_DATA: 'GENERATING_NEW_OTP_KEY_DATA',
  GENERATE_NEW_OTP_KEY_DATA_SUCCESS: 'GENERATE_NEW_OTP_KEY_DATA_SUCCESS',
  GENERATE_NEW_OTP_KEY_DATA_FAILED: 'GENERATE_NEW_OTP_KEY_DATA_FAILED',

  DEFINE_KEY_CITIES: 'DEFINE_KEY_CITIES',
  DEFINING_KEY_CITIES: 'DEFINING_KEY_CITIES',
  DEFINE_KEY_CITIES_SUCCESS: 'DEFINE_KEY_CITIES_SUCCESS',
  DEFINE_KEY_CITIES_FAILED: 'DEFINE_KEY_CITIES_FAILED',

  CHANGE_STATUS_ADDRESS_DATA: 'CHANGE_STATUS_ADDRESS_DATA',
  CHANGING_STATUS_ADDRESS_DATA: 'CHANGING_STATUS_ADDRESS_DATA',
  CHANGE_STATUS_ADDRESS_DATA_SUCCESS: 'CHANGE_STATUS_ADDRESS_DATA_SUCCESS',
  CHANGE_STATUS_ADDRESS_DATA_FAILED: 'CHANGE_STATUS_ADDRESS_DATA_FAILED',
  // end: address

  // start: user
  FETCH_USER_DATA: 'FETCH_USER_DATA',
  FETCHING_USER_DATA: 'FETCHING_USER_DATA',
  FETCH_USER_DATA_SUCCESS: 'FETCH_USER_DATA_SUCCESS',
  FETCH_USER_DATA_FAILED: 'FETCH_USER_DATA_FAILED',
  LOADING_MORE_USER_DATA: 'LOADING_MORE_USER_DATA',

  FETCH_USER_SYSTEM_LOGS: 'FETCH_USER_SYSTEM_LOGS',
  LOADING_MORE_USER_SYSTEM_LOGS: 'LOADING_MORE_USER_SYSTEM_LOGS',
  FETCHING_USER_SYSTEM_LOGS: 'FETCHING_USER_SYSTEM_LOGS',
  FETCH_USER_SYSTEM_LOGS_SUCCESS: 'FETCH_USER_SYSTEM_LOGS_SUCCESS',
  FETCH_USER_SYSTEM_LOGS_FAILED: 'FETCH_USER_SYSTEM_LOGS_FAILED',
  PUSH_USER_SYSTEM_LOGS: 'PUSH_USER_SYSTEM_LOGS',
  RESET_USER_SYSTEM_LOGS: 'RESET_USER_SYSTEM_LOGS',

  ADD_USER_DATA: 'ADD_USER_DATA',
  ADDING_USER_DATA: 'ADDING_USER_DATA',
  ADD_USER_DATA_SUCCESS: 'ADD_USER_DATA_SUCCESS',
  ADD_USER_DATA_FAILED: 'ADD_USER_DATA_FAILED',

  EDIT_USER_DATA: 'EDIT_USER_DATA',
  EDITING_USER_DATA: 'EDITING_USER_DATA',
  EDIT_USER_DATA_SUCCESS: 'EDIT_USER_DATA_SUCCESS',
  EDIT_USER_DATA_FAILED: 'EDIT_USER_DATA_FAILED',

  DELETE_USER_DATA: 'DELETE_USER_DATA',
  DELETING_USER_DATA: 'DELETING_USER_DATA',
  DELETE_USER_DATA_SUCCESS: 'DELETE_USER_DATA_SUCCESS',
  DELETE_USER_DATA_FAILED: 'DELETE_USER_DATA_FAILED',

  RESET_USER_PASSWORD: 'RESET_USER_PASSWORD',
  RESETTING_USER_PASSWORD: 'RESETTING_USER_PASSWORD',
  RESET_USER_PASSWORD_SUCCESS: 'RESET_USER_PASSWORD_SUCCESS',
  RESET_USER_PASSWORD_FAILED: 'RESET_USER_PASSWORD_FAILED',

  LOCK_USER: 'LOCK_USER',
  UNLOCK_USER: 'UNLOCK_USER',
  UNLOCK_USER_ACCOUNT: 'UNLOCK_USER_ACCOUNT',
  UNLOCKING_USER: 'UNLOCKING_USER',
  UNLOCK_USER_SUCCESS: 'UNLOCK_USER_SUCCESS',
  UNLOCK_USER_FAILED: 'UNLOCK_USER_FAILED',

  GET_USER_REQUEST: 'GET_USER_REQUEST',
  GET_USER_SUCCESS: 'GET_USER_SUCCESS',
  GET_USER_FAILED: 'GET_USER_FAILED',

  CHANGE_USER_STATUS: 'CHANGE_USER_STATUS',
  CHANGING_USER_STATUS: 'CHANGING_USER_STATUS',
  CHANGE_USER_STATUS_SUCCESS: 'CHANGE_USER_STATUS_SUCCESS',
  CHANGE_USER_STATUS_FAILED: 'CHANGE_USER_STATUS_FAILED',

  INVITE_USER_DATA: 'INVITE_USER_DATA',
  INVITING_USER_DATA: 'INVITING_USER_DATA',
  INVITE_USER_DATA_SUCCESS: 'INVITE_USER_DATA_SUCCESS',
  INVITE_USER_DATA_FAILED: 'INVITE_USER_DATA_FAILED',

  RESEND_INVITE_USER_DATA: 'RESEND_INVITE_USER_DATA',
  RESEND_INVITING_USER_DATA: 'RESEND_INVITING_USER_DATA',
  RESEND_INVITE_USER_DATA_SUCCESS: 'RESEND_INVITE_USER_DATA_SUCCESS',
  RESEND_INVITE_USER_DATA_FAILED: 'RESEND_INVITE_USER_DATA_FAILED',

  FETCH_INVITED_USER_DATA: 'FETCH_INVITED_USER_DATA',
  FETCHING_INVITED_USER_DATA: 'FETCHING_INVITED_USER_DATA',
  FETCH_INVITED_USER_DATA_SUCCESS: 'FETCH_INVITED_USER_DATA_SUCCESS',
  FETCH_INVITED_USER_DATA_FAILED: 'FETCH_INVITED_USER_DATA_FAILED',

  LOG_ACCESS_INVITE_DATA: 'LOG_ACCESS_INVITE_DATA',
  LOGGING_ACCESS_INVITE_DATA: 'LOGGING_ACCESS_INVITE_DATA',
  LOG_ACCESS_INVITE_DATA_SUCCESS: 'LOG_ACCESS_INVITE_DATA_SUCCESS',
  LOG_ACCESS_INVITE_DATA_FAILED: 'LOG_ACCESS_INVITE_DATA_FAILED',

  FETCH_ALL_INVITED_USERS_DATA: 'FETCH_ALL_INVITED_USERS_DATA',
  FETCHING_ALL_INVITED_USERS_DATA: 'FETCHING_ALL_INVITED_USERS_DATA',
  FETCH_ALL_INVITED_USERS_DATA_SUCCESS: 'FETCH_ALL_INVITED_USERS_DATA_SUCCESS',
  FETCH_ALL_INVITED_USERS_DATA_FAILED: 'FETCH_ALL_INVITED_USERS_DATA_FAILED',

  SIGN_UP_USER_DATA: 'SIGN_UP_USER_DATA',
  SIGNING_UP_USER_DATA: 'SIGNING_UP_USER_DATA',
  SIGN_UP_USER_DATA_SUCCESS: 'SIGN_UP_USER_DATA_SUCCESS',
  SIGN_UP_USER_DATA_FAILED: 'SIGN_UP_USER_DATA_FAILED',
  // end: user

  // start: department
  FETCH_ALL_USER_DEPT_DATA: 'FETCH_ALL_USER_DEPT_DATA',
  FETCHING_ALL_USER_DEPT_DATA: 'FETCHING_ALL_USER_DEPT_DATA',
  FETCH_ALL_USER_DEPT_DATA_SUCCESS: 'FETCH_ALL_USER_DEPT_DATA_SUCCESS',
  FETCH_ALL_USER_DEPT_DATA_FAILED: 'FETCH_ALL_USER_DEPT_DATA_FAILED',
  // end: department

  // start: lookups
  FETCH_LOOKUPS_DATA: 'FETCH_LOOKUPS_DATA',
  FETCHING_LOOKUPS_DATA: 'FETCHING_LOOKUPS_DATA',
  FETCH_LOOKUPS_DATA_SUCCESS: 'FETCH_LOOKUPS_DATA_SUCCESS',
  FETCH_LOOKUPS_DATA_FAILED: 'FETCH_LOOKUPS_DATA_FAILED',
  RESET_LOOKUPS_DATA: 'RESET_LOOKUPS_DATA',

  ADD_LOOKUPS_DATA: 'ADD_LOOKUPS_DATA',
  ADDING_LOOKUPS_DATA: 'ADDING_LOOKUPS_DATA',
  ADD_LOOKUPS_DATA_SUCCESS: 'ADD_LOOKUPS_DATA_SUCCESS',
  ADD_LOOKUPS_DATA_FAILED: 'ADD_LOOKUPS_DATA_FAILED',

  EDIT_LOOKUPS_DATA: 'EDIT_LOOKUPS_DATA',
  EDITING_LOOKUPS_DATA: 'EDITING_LOOKUPS_DATA',
  EDIT_LOOKUPS_DATA_SUCCESS: 'EDIT_LOOKUPS_DATA_SUCCESS',
  EDIT_LOOKUPS_DATA_FAILED: 'EDIT_LOOKUPS_DATA_FAILED',

  EDIT_SYSTEM_MODULE_STATUS: 'EDIT_SYSTEM_MODULE_STATUS',
  EDITING_SYSTEM_MODULE_STATUS: 'EDITING_SYSTEM_MODULE_STATUS',
  EDIT_SYSTEM_MODULE_STATUS_SUCCESS: 'EDIT_SYSTEM_MODULE_STATUS_SUCCESS',
  EDIT_SYSTEM_MODULE_STATUS_FAILED: 'EDIT_SYSTEM_MODULE_STATUS_FAILED',

  EDIT_LOOKUP_GROUP_DATA: 'EDIT_LOOKUP_GROUP_DATA',
  EDITING_LOOKUP_GROUP_DATA: 'EDITING_LOOKUP_GROUP_DATA',
  EDIT_LOOKUP_GROUP_DATA_SUCCESS: 'EDIT_LOOKUP_GROUP_DATA_SUCCESS',
  EDIT_LOOKUP_GROUP_DATA_FAILED: 'EDIT_LOOKUP_GROUP_DATA_FAILED',

  DELETE_LOOKUP_DATA: 'DELETE_LOOKUP_DATA',
  DELETING_LOOKUP_DATA: 'DELETING_LOOKUP_DATA',
  DELETE_LOOKUP_DATA_SUCCESS: 'DELETE_LOOKUP_DATA_SUCCESS',
  DELETE_LOOKUP_DATA_FAILED: 'DELETE_LOOKUP_DATA_FAILED',
  // end: lookups

  FETCH_MODULE_DATA: 'FETCH_MODULE_DATA',
  FETCHING_MODULE_DATA: 'FETCHING_MODULE_DATA',
  FETCH_MODULE_DATA_SUCCESS: 'FETCH_MODULE_DATA_SUCCESS',
  FETCH_MODULE_DATA_FAILED: 'FETCH_MODULE_DATA_FAILED',
  RESET_MODULE_DATA: 'RESET_MODULE_DATA',

  ADD_MODULE_DATA: 'ADD_MODULE_DATA',
  ADDING_MODULE_DATA: 'ADDING_MODULE_DATA',
  ADD_MODULE_DATA_SUCCESS: 'ADD_MODULE_DATA_SUCCESS',
  ADD_MODULE_DATA_FAILED: 'ADD_MODULE_DATA_FAILED',

  FETCH_PCHANNEL_DATA: 'FETCH_PCHANNEL_DATA',
  FETCHING_PCHANNEL_DATA: 'FETCHING_PCHANNEL_DATA',
  FETCH_PCHANNEL_DATA_SUCCESS: 'FETCH_PCHANNEL_DATA_SUCCESS',
  FETCH_PCHANNEL_DATA_FAILED: 'FETCH_PCHANNEL_DATA_FAILED',

  FETCH_NOTIFICATION_DATA: 'FETCH_NOTIFICATION_DATA',
  FETCHING_NOTIFICATION_DATA: 'FETCHING_NOTIFICATION_DATA',
  FETCH_NOTIFICATION_DATA_SUCCESS: 'FETCH_NOTIFICATION_DATA_SUCCESS',
  FETCH_NOTIFICATION_DATA_FAILED: 'FETCH_NOTIFICATION_DATA_FAILED',

  UPDATE_APP_NOTIFICATION: 'UPDATE_APP_NOTIFICATION',
  UPDATING_APP_NOTIFICATION: 'UPDATING_APP_NOTIFICATION',
  UPDATE_APP_NOTIFICATION_SUCCESS: 'UPDATE_APP_NOTIFICATION_SUCCESS',
  UPDATE_APP_NOTIFICATION_FAILED: 'UPDATE_APP_NOTIFICATION_FAILED',
  RESET_UPDATE_APP_NOTIFICATION: 'RESET_UPDATE_APP_NOTIFICATION',

  ADD_NOTIFICATION_DATA: 'ADD_NOTIFICATION_DATA',
  ADDING_NOTIFICATION_DATA: 'ADDING_NOTIFICATION_DATA',
  ADD_NOTIFICATION_DATA_SUCCESS: 'ADD_NOTIFICATION_DATA_SUCCESS',
  ADD_NOTIFICATION_DATA_FAILED: 'ADD_NOTIFICATION_DATA_FAILED',

  GET_USER_LIST_BY_ROLE: 'GET_USER_LIST_BY_ROLE',
  GETTING_USER_LIST_BY_ROLE: 'GETTING_USER_LIST_BY_ROLE',
  GET_USER_LIST_BY_ROLE_SUCCESS: 'GET_USER_LIST_BY_ROLE_SUCCESS',
  GET_USER_LIST_BY_ROLE_FAILED: 'GET_USER_LIST_BY_ROLE_FAILED',

  FETCH_USERS: 'FETCH_USERS',
  FETCHING_USERS: 'FETCHING_USERS',
  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILED: 'FETCH_USERS_FAILED',

  REORDER_LOOKUP_DATA: 'REORDER_LOOKUP_DATA',
  REORDERING_LOOKUP_DATA: 'REORDERING_LOOKUP_DATA',
  REORDER_LOOKUP_DATA_SUCCESS: 'REORDER_LOOKUP_DATA_SUCCESS',
  REORDER_LOOKUP_DATA_FAILED: 'REORDER_LOOKUP_DATA_FAILED',

  REORDER_PAGE_DATA: 'REORDER_PAGE_DATA',
  REORDERING_PAGE_DATA: 'REORDERING_PAGE_DATA',
  REORDER_PAGE_DATA_SUCCESS: 'REORDER_PAGE_DATA_SUCCESS',
  REORDER_PAGE_DATA_FAILED: 'REORDER_PAGE_DATA_FAILED',

  REORDER_MODULE_DATA: 'REORDER_MODULE_DATA',
  REORDERING_MODULE_DATA: 'REORDERING_MODULE_DATA',
  REORDER_MODULE_DATA_SUCCESS: 'REORDER_MODULE_DATA_SUCCESS',
  REORDER_MODULE_DATA_FAILED: 'REORDER_MODULE_DATA_FAILED',

  FETCH_EXTERNAL_RECIPIENTS_DATA: 'FETCH_EXTERNAL_RECIPIENTS_DATA',
  FETCHING_EXTERNAL_RECIPIENTS_DATA: 'FETCHING_EXTERNAL_RECIPIENTS_DATA',
  FETCH_EXTERNAL_RECIPIENTS_DATA_SUCCESS: 'FETCH_EXTERNAL_RECIPIENTS_DATA_SUCCESS',
  FETCH_EXTERNAL_RECIPIENTS_DATA_FAILED: 'FETCH_EXTERNAL_RECIPIENTS_DATA_FAILED',

  EDIT_EXTERNAL_RECIPIENT_DATA: 'EDIT_EXTERNAL_RECIPIENT_DATA',
  EDITING_EXTERNAL_RECIPIENT_DATA: 'EDITING_EXTERNAL_RECIPIENT_DATA',
  EDIT_EXTERNAL_RECIPIENT_DATA_SUCCESS: 'EDIT_EXTERNAL_RECIPIENT_DATA_SUCCESS',
  EDIT_EXTERNAL_RECIPIENT_DATA_FAILED: 'EDIT_EXTERNAL_RECIPIENT_DATA_FAILED',

  FETCH_LOOKUP_VALIDATION_DATA: 'FETCH_LOOKUP_VALIDATION_DATA',
  FETCHING_LOOKUP_VALIDATION_DATA: 'FETCHING_LOOKUP_VALIDATION_DATA',
  FETCH_LOOKUP_VALIDATION_DATA_SUCCESS: 'FETCH_LOOKUP_VALIDATION_DATA_SUCCESS',
  FETCH_LOOKUP_VALIDATION_DATA_FAILED: 'FETCH_LOOKUP_VALIDATION_DATA_FAILED',

  SET_LOOKUP_VALIDATION_DATA: 'SET_LOOKUP_VALIDATION_DATA',
  SETTING_LOOKUP_VALIDATION_DATA: 'SETTING_LOOKUP_VALIDATION_DATA',
  SET_LOOKUP_VALIDATION_DATA_SUCCESS: 'SET_LOOKUP_VALIDATION_DATA_SUCCESS',
  SET_LOOKUP_VALIDATION_DATA_FAILED: 'SET_LOOKUP_VALIDATION_DATA_FAILED',

  EDIT_LOOKUP_VALIDATION_DATA: 'EDIT_LOOKUP_VALIDATION_DATA',
  EDITING_LOOKUP_VALIDATION_DATA: 'EDITING_LOOKUP_VALIDATION_DATA',
  EDIT_LOOKUP_VALIDATION_DATA_SUCCESS: 'EDIT_LOOKUP_VALIDATION_DATA_SUCCESS',
  EDIT_LOOKUP_VALIDATION_DATA_FAILED: 'EDIT_LOOKUP_VALIDATION_DATA_FAILED',

  DELETE_LOOKUP_VALIDATION_DATA: 'DELETE_LOOKUP_VALIDATION_DATA',
  DELETING_LOOKUP_VALIDATION_DATA: 'DELETING_LOOKUP_VALIDATION_DATA',
  DELETE_LOOKUP_VALIDATION_DATA_SUCCESS: 'DELETE_LOOKUP_VALIDATION_DATA_SUCCESS',
  DELETE_LOOKUP_VALIDATION_DATA_FAILED: 'DELETE_LOOKUP_VALIDATION_DATA_FAILED',

  FETCH_PAYMENT_CHANNEL_LIST_DATA: 'FETCH_PAYMENT_CHANNEL_LIST_DATA',
  FETCHING_PAYMENT_CHANNEL_LIST_DATA: 'FETCHING_PAYMENT_CHANNEL_LIST_DATA',
  FETCH_PAYMENT_CHANNEL_LIST_DATA_SUCCESS: 'FETCH_PAYMENT_CHANNEL_LIST_DATA_SUCCESS',
  FETCH_PAYMENT_CHANNEL_LIST_DATA_FAILED: 'FETCH_PAYMENT_CHANNEL_LIST_DATA_FAILED',
  SET_PAYMENT_CHANNEL_FILTER: 'SET_PAYMENT_CHANNEL_FILTER',

  ADD_PAYMENT_CHANNEL_DATA: 'ADD_PAYMENT_CHANNEL_DATA',
  ADDING_PAYMENT_CHANNEL_DATA: 'ADDING_PAYMENT_CHANNEL_DATA',
  ADD_PAYMENT_CHANNEL_DATA_SUCCESS: 'ADD_PAYMENT_CHANNEL_DATA_SUCCESS',
  ADD_PAYMENT_CHANNEL_DATA_FAILED: 'ADD_PAYMENT_CHANNEL_DATA_FAILED',

  FETCH_PAYMENT_METHOD_LIST_DATA: 'FETCH_PAYMENT_METHOD_LIST_DATA',
  FETCHING_PAYMENT_METHOD_LIST_DATA: 'FETCHING_PAYMENT_METHOD_LIST_DATA',
  FETCH_PAYMENT_METHOD_LIST_DATA_SUCCESS: 'FETCH_PAYMENT_METHOD_LIST_DATA_SUCCESS',
  FETCH_PAYMENT_METHOD_LIST_DATA_FAILED: 'FETCH_PAYMENT_METHOD_LIST_DATA_FAILED',

  FETCH_TEMPLATE_DATA: 'FETCH_TEMPLATE_DATA',
  FETCHING_TEMPLATE_DATA: 'FETCHING_TEMPLATE_DATA',
  FETCH_TEMPLATE_DATA_SUCCESS: 'FETCH_TEMPLATE_DATA_SUCCESS',
  FETCH_TEMPLATE_DATA_FAILED: 'FETCH_TEMPLATE_DATA_FAILED',
  RESET_TEMPLATE_DATA: 'RESET_TEMPLATE_DATA',

  FETCH_BANK_TEMPLATE_DATA: 'FETCH_BANK_TEMPLATE_DATA',
  FETCHING_BANK_TEMPLATE_DATA: 'FETCHING_BANK_TEMPLATE_DATA',
  FETCH_BANK_TEMPLATE_DATA_SUCCESS: 'FETCH_BANK_TEMPLATE_DATA_SUCCESS',
  FETCH_BANK_TEMPLATE_DATA_FAILED: 'FETCH_BANK_TEMPLATE_DATA_FAILED',

  ADD_TEMPLATE_DATA: 'ADD_TEMPLATE_DATA',
  ADDING_TEMPLATE_DATA: 'ADDING_TEMPLATE_DATA',
  ADD_TEMPLATE_DATA_SUCCESS: 'ADD_TEMPLATE_DATA_SUCCESS',
  ADD_TEMPLATE_DATA_FAILED: 'ADD_TEMPLATE_DATA_FAILED',

  ADD_BANK_TEMPLATE_DATA: 'ADD_BANK_TEMPLATE_DATA',
  ADDING_BANK_TEMPLATE_DATA: 'ADDING_BANK_TEMPLATE_DATA',
  ADD_BANK_TEMPLATE_DATA_SUCCESS: 'ADD_BANK_TEMPLATE_DATA_SUCCESS',
  ADD_BANK_TEMPLATE_DATA_FAILED: 'ADD_BANK_TEMPLATE_DATA_FAILED',

  EDIT_TEMPLATE_DATA: 'EDIT_TEMPLATE_DATA',
  EDITING_TEMPLATE_DATA: 'EDITING_TEMPLATE_DATA',
  EDIT_TEMPLATE_DATA_SUCCESS: 'EDIT_TEMPLATE_DATA_SUCCESS',
  EDIT_TEMPLATE_DATA_FAILED: 'EDIT_TEMPLATE_DATA_FAILED',

  FETCH_UPLOADED_FILES: 'FETCH_UPLOADED_FILES',
  FETCHING_UPLOADED_FILES: 'FETCHING_UPLOADED_FILES',
  FETCH_UPLOADED_FILES_SUCCESS: 'FETCH_UPLOADED_FILES_SUCCESS',
  FETCH_UPLOADED_FILES_FAILED: 'FETCH_UPLOADED_FILES_FAILED',

  UPLOAD_FILE_TRANSACTION_DATA: 'UPLOAD_FILE_TRANSACTION_DATA',
  UPLOADING_FILE_TRANSACTION_DATA: 'UPLOADING_FILE_TRANSACTION_DATA',
  UPLOAD_FILE_TRANSACTION_DATA_SUCCESS: 'UPLOAD_FILE_TRANSACTION_DATA_SUCCESS',
  UPLOAD_FILE_TRANSACTION_DATA_FAILED: 'UPLOAD_FILE_TRANSACTION_DATA_FAILED',

  UPLOAD_BANK_TRX_DATA: 'UPLOAD_BANK_TRX_DATA',
  UPLOADING_BANK_TRX_DATA: 'UPLOADING_BANK_TRX_DATA',
  UPLOAD_BANK_TRX_DATA_SUCCESS: 'UPLOAD_BANK_TRX_DATA_SUCCESS',
  UPLOAD_BANK_TRX_DATA_FAILED: 'UPLOAD_BANK_TRX_DATA_FAILED',

  UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA: 'UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA',
  UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA: 'UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA',
  UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_SUCCESS: 'UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_SUCCESS',
  UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED: 'UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED',

  UPLOAD_LEADS_FILE_DATA: 'UPLOAD_LEADS_FILE_DATA',
  UPLOADING_LEADS_FILE_DATA: 'UPLOADING_LEADS_FILE_DATA',
  UPLOAD_LEADS_FILE_DATA_SUCCESS: 'UPLOAD_LEADS_FILE_DATA_SUCCESS',
  UPLOAD_LEADS_FILE_DATA_FAILED: 'UPLOAD_LEADS_FILE_DATA_FAILED',
  DONE_PARSING_LEADS_FILE_DATA: 'DONE_PARSING_LEADS_FILE_DATA',

  REUPLOAD_LEADS_FILE_DATA: 'REUPLOAD_LEADS_FILE_DATA',
  REUPLOADING_LEADS_FILE_DATA: 'REUPLOADING_LEADS_FILE_DATA',
  REUPLOAD_LEADS_FILE_DATA_SUCCESS: 'REUPLOAD_LEADS_FILE_DATA_SUCCESS',
  REUPLOAD_LEADS_FILE_DATA_FAILED: 'REUPLOAD_LEADS_FILE_DATA_FAILED',

  REUPLOAD_FILE_TRANSACTION_DATA: 'REUPLOAD_FILE_TRANSACTION_DATA',
  REUPLOADING_FILE_TRANSACTION_DATA: 'REUPLOADING_FILE_TRANSACTION_DATA',
  REUPLOAD_FILE_TRANSACTION_DATA_SUCCESS: 'REUPLOAD_FILE_TRANSACTION_DATA_SUCCESS',
  REUPLOAD_FILE_TRANSACTION_DATA_FAILED: 'REUPLOAD_FILE_TRANSACTION_DATA_FAILED',

  GET_PRE_SIGNED_URL: 'GET_PRE_SIGNED_URL',
  GETTING_PRE_SIGNED_URL: 'GETTING_PRE_SIGNED_URL',
  GET_PRE_SIGNED_URL_SUCCESS: 'GET_PRE_SIGNED_URL_SUCCESS',
  GET_PRE_SIGNED_URL_FAILED: 'GET_PRE_SIGNED_URL_FAILED',

  GET_PRE_SIGNED_URL_WITH_KEY: 'GET_PRE_SIGNED_URL_WITH_KEY',
  GETTING_PRE_SIGNED_URL_WITH_KEY: 'GETTING_PRE_SIGNED_URL_WITH_KEY',
  GET_PRE_SIGNED_URL_WITH_KEY_SUCCESS: 'GET_PRE_SIGNED_URL_WITH_KEY_SUCCESS',
  GET_PRE_SIGNED_URL_WITH_KEY_FAILED: 'GET_PRE_SIGNED_URL_WITH_KEY_FAILED',

  GET_LIST_OF_PRE_SIGNED_URL: 'GET_LIST_OF_PRE_SIGNED_URL',
  GETTING_LIST_OF_PRE_SIGNED_URL: 'GETTING_LIST_OF_PRE_SIGNED_URL',
  GET_LIST_OF_PRE_SIGNED_URL_SUCCESS: 'GET_LIST_OF_PRE_SIGNED_URL_SUCCESS',
  GET_LIST_OF_PRE_SIGNED_URL_FAILED: 'GET_LIST_OF_PRE_SIGNED_URL_FAILED',

  FETCH_COSMOS_LOGS: 'FETCH_COSMOS_LOGS',
  FETCHING_COSMOS_LOGS: 'FETCHING_COSMOS_LOGS',
  FETCH_COSMOS_LOGS_SUCCESS: 'FETCH_COSMOS_LOGS_SUCCESS',
  FETCH_COSMOS_LOGS_FAILED: 'FETCH_COSMOS_LOGS_FAILED',

  FETCH_SYSTEM_SETTINGS: 'FETCH_SYSTEM_SETTINGS',
  FETCHING_SYSTEM_SETTINGS: 'FETCHING_SYSTEM_SETTINGS',
  FETCH_SYSTEM_SETTINGS_SUCCESS: 'FETCH_SYSTEM_SETTINGS_SUCCESS',
  FETCH_SYSTEM_SETTINGS_FAILED: 'FETCH_SYSTEM_SETTINGS_FAILED',

  ADD_SYSTEM_SETTINGS: 'ADD_SYSTEM_SETTINGS',
  ADDING_SYSTEM_SETTINGS: 'ADDING_SYSTEM_SETTINGS',
  ADD_SYSTEM_SETTINGS_SUCCESS: 'ADD_SYSTEM_SETTINGS_SUCCESS',
  ADD_SYSTEM_SETTINGS_FAILED: 'ADD_SYSTEM_SETTINGS_FAILED',

  EDIT_SYSTEM_SETTINGS: 'EDIT_SYSTEM_SETTINGS',
  EDITING_SYSTEM_SETTINGS: 'EDITING_SYSTEM_SETTINGS',
  EDIT_SYSTEM_SETTINGS_SUCCESS: 'EDIT_SYSTEM_SETTINGS_SUCCESS',
  EDIT_SYSTEM_SETTINGS_FAILED: 'EDIT_SYSTEM_SETTINGS_FAILED',

  FETCH_LOGS_BY_ITEM_ID: 'FETCH_LOGS_BY_ITEM_ID',
  FETCHING_LOGS_BY_ITEM_ID: 'FETCHING_LOGS_BY_ITEM_ID',
  FETCH_LOGS_BY_ITEM_ID_SUCCESS: 'FETCH_LOGS_BY_ITEM_ID_SUCCESS',
  FETCH_LOGS_BY_ITEM_ID_FAILED: 'FETCH_LOGS_BY_ITEM_ID_FAILED',

  //payment channel
  EDIT_PAYMENT_CHANNEL_DATA: 'EDIT_PAYMENT_CHANNEL_DATA',
  EDITING_PAYMENT_CHANNEL_DATA: 'EDITING_PAYMENT_CHANNEL_DATA',
  EDIT_PAYMENT_CHANNEL_DATA_SUCCESS: 'EDIT_PAYMENT_CHANNEL_DATA_SUCCESS',
  EDIT_PAYMENT_CHANNEL_DATA_FAILED: 'EDIT_PAYMENT_CHANNEL_DATA_FAILED',

  //start: PaynamicsBank
  FETCH_PAYNAMICS_BANK_DATA: 'FETCH_PAYNAMICS_BANK_DATA',
  FETCHING_PAYNAMICS_BANK_DATA: 'FETCHING_PAYNAMICS_BANK_DATA',
  FETCH_PAYNAMICS_BANK_DATA_SUCCESS: 'FETCH_PAYNAMICS_BANK_DATA_SUCCESS',
  FETCH_PAYNAMICS_BANK_DATA_FAILED: 'FETCH_PAYNAMICS_BANK_DATA_FAILED',
  RESET_PAYNAMICS_BANK_DATA: 'RESET_PAYNAMICS_BANK_DATA',

  ADD_PAYNAMICS_BANK: 'ADD_PAYNAMICS_BANK',
  ADDING_PAYNAMICS_BANK: 'ADDING_PAYNAMICS_BANK',
  ADD_PAYNAMICS_BANK_SUCCESS: 'ADD_PAYNAMICS_BANK_SUCCESS',
  ADD_PAYNAMICS_BANK_FAILED: 'ADD_PAYNAMICS_BANK_FAILED',

  EDIT_PAYNAMICS_BANK: 'EDIT_PAYNAMICS_BANK',
  EDITING_PAYNAMICS_BANK: 'EDITING_PAYNAMICS_BANK',
  EDIT_PAYNAMICS_BANK_SUCCESS: 'EDIT_PAYNAMICS_BANK_SUCCESS',
  EDIT_PAYNAMICS_BANK_FAILED: 'EDIT_PAYNAMICS_BANK_FAILED',

  EDIT_PAYNAMICS_BANK_TEMPLATE_DATA: 'EDIT_PAYNAMICS_BANK_TEMPLATE_DATA',
  EDITING_PAYNAMICS_BANK_TEMPLATE_DATA: 'EDITING_PAYNAMICS_BANK_TEMPLATE_DATA',
  EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_SUCCESS: 'EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_SUCCESS',
  EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_FAILED: 'EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_FAILED',
  //end: PaynamicsBank

  ADD_PAGE_ACTION: 'ADD_PAGE_ACTION',
  ADDING_PAGE_ACTION: 'ADDING_PAGE_ACTION',
  ADD_PAGE_ACTION_SUCCESS: 'ADD_PAGE_ACTION_SUCCESS',
  ADD_PAGE_ACTION_FAILED: 'ADD_PAGE_ACTION_FAILED',

  EDIT_PAGE_ACTION: 'EDIT_PAGE_ACTION',
  EDITING_PAGE_ACTION: 'EDITING_PAGE_ACTION',
  EDIT_PAGE_ACTION_SUCCESS: 'EDIT_PAGE_ACTION_SUCCESS',
  EDIT_PAGE_ACTION_FAILED: 'EDIT_PAGE_ACTION_FAILED',

  FETCH_OTP_SERVICE_DATA: 'FETCH_OTP_SERVICE_DATA',
  FETCHING_OTP_SERVICE_DATA: 'FETCHING_OTP_SERVICE_DATA',
  FETCH_OTP_SERVICE_DATA_SUCCESS: 'FETCH_OTP_SERVICE_DATA_SUCCESS',
  FETCH_OTP_SERVICE_DATA_FAILED: 'FETCH_OTP_SERVICE_DATA_FAILED',
  SET_IS_RESET_OTP_SERVICE_ACTIVE_DATA: 'SET_IS_RESET_OTP_SERVICE_ACTIVE_DATA',

  SET_ACTIVE_OTP_SERVICE: 'SET_ACTIVE_OTP_SERVICE',

  FETCH_OTP_INTEGRATORS: 'FETCH_OTP_INTEGRATORS',
  FETCHING_OTP_INTEGRATORS: 'FETCHING_OTP_INTEGRATORS',
  FETCH_OTP_INTEGRATORS_SUCCESS: 'FETCH_OTP_INTEGRATORS_SUCCESS',
  FETCH_OTP_INTEGRATORS_FAILED: 'FETCH_OTP_INTEGRATORS_FAILED',

  FETCH_OTP_LOGS: 'FETCH_OTP_LOGS',
  FETCHING_OTP_LOGS: 'FETCHING_OTP_LOGS',
  FETCH_OTP_LOGS_SUCCESS: 'FETCH_OTP_LOGS_SUCCESS',
  FETCH_OTP_LOGS_FAILED: 'FETCH_OTP_LOGS_FAILED',

  FETCH_OTP_LOGS_ACTION_COUNT: 'FETCH_OTP_LOGS_ACTION_COUNT',
  FETCHING_OTP_LOGS_ACTION_COUNT: 'FETCHING_OTP_LOGS_ACTION_COUNT',
  FETCH_OTP_LOGS_ACTION_COUNT_SUCCESS: 'FETCH_OTP_LOGS_ACTION_COUNT_SUCCESS',
  FETCH_OTP_LOGS_ACTION_COUNT_FAILED: 'FETCH_OTP_LOGS_ACTION_COUNT_FAILED',

  CLEAR_MESSAGE: 'CLEAR_MESSAGE',

  EDIT_NOTIFICATION_SETTING: 'EDIT_NOTIFICATION_SETTING',
  EDITING_NOTIFICATION_SETTING: 'EDITING_NOTIFICATION_SETTING',
  EDIT_NOTIFICATION_SETTING_SUCCESS: 'EDIT_NOTIFICATION_SETTING_SUCCESS',
  EDIT_NOTIFICATION_SETTING_FAILED: 'EDIT_NOTIFICATION_SETTING_FAILED',

  FETCH_LOOKUPS_DATA_REVAMPED: 'FETCH_LOOKUPS_DATA_REVAMPED',
  FETCHING_LOOKUPS_DATA_REVAMPED: 'FETCHING_LOOKUPS_DATA_REVAMPED',
  FETCH_LOOKUPS_DATA_REVAMPED_SUCCESS: 'FETCH_LOOKUPS_DATA_REVAMPED_SUCCESS',
  FETCH_LOOKUPS_DATA_REVAMPED_FAILED: 'FETCH_LOOKUPS_DATA_REVAMPED_FAILED',

  EDITED_LOOKUPS_DATA: 'EDITED_LOOKUPS_DATA',

  ADD_PAYMENT_CHANNEL_PAYLOAD: 'ADD_PAYMENT_CHANNEL_PAYLOAD',
  ADDING_PAYMENT_CHANNEL_PAYLOAD: 'ADDING_PAYMENT_CHANNEL_PAYLOAD',
  ADD_PAYMENT_CHANNEL_PAYLOAD_SUCCESS: 'ADD_PAYMENT_CHANNEL_PAYLOAD_SUCCESS',
  ADD_PAYMENT_CHANNEL_PAYLOAD_FAILED: 'ADD_PAYMENT_CHANNEL_PAYLOAD_FAILED',

  FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID: 'FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID',
  FETCHING_PAYMENT_CHANNEL_PAYLOAD_BY_ID: 'FETCHING_PAYMENT_CHANNEL_PAYLOAD_BY_ID',
  FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_SUCCESS: 'FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_SUCCESS',
  FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_FAILED: 'FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_FAILED',
  RESET_PAYMENT_CHANNEL_PAYLOAD_BY_ID: 'RESET_PAYMENT_CHANNEL_PAYLOAD_BY_ID',

  UPDATE_PAYMENT_CHANNEL_PAYLOAD: 'UPDATE_PAYMENT_CHANNEL_PAYLOAD',
  UPDATING_PAYMENT_CHANNEL_PAYLOAD: 'UPDATING_PAYMENT_CHANNEL_PAYLOAD',
  UPDATE_PAYMENT_CHANNEL_PAYLOAD_SUCCESS: 'UPDATE_PAYMENT_CHANNEL_PAYLOAD_SUCCESS',
  UPDATE_PAYMENT_CHANNEL_PAYLOAD_FAILED: 'UPDATE_PAYMENT_CHANNEL_PAYLOAD_FAILED',

  ADD_INSTALLMENT_MODE_PAYLOAD: 'ADD_INSTALLMENT_MODE_PAYLOAD',
  ADDING_INSTALLMENT_MODE_PAYLOAD: 'ADDING_INSTALLMENT_MODE_PAYLOAD',
  ADD_INSTALLMENT_MODE_PAYLOAD_SUCCESS: 'ADD_INSTALLMENT_MODE_PAYLOAD_SUCCESS',
  ADD_INSTALLMENT_MODE_PAYLOAD_FAILED: 'ADD_INSTALLMENT_MODE_PAYLOAD_FAILED',

  FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID: 'FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID',
  FETCHING_INSTALLMENT_MODE_PAYLOAD_BY_ID: 'FETCHING_INSTALLMENT_MODE_PAYLOAD_BY_ID',
  FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_SUCCESS: 'FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_SUCCESS',
  FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_FAILED: 'FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_FAILED',
  RESET_INSTALLMENT_MODE_PAYLOAD_BY_ID: 'RESET_INSTALLMENT_MODE_PAYLOAD_BY_ID',

  UPDATE_INSTALLMENT_MODE_PAYLOAD: 'UPDATE_INSTALLMENT_MODE_PAYLOAD',
  UPDATING_INSTALLMENT_MODE_PAYLOAD: 'UPDATING_INSTALLMENT_MODE_PAYLOAD',
  UPDATE_INSTALLMENT_MODE_PAYLOAD_SUCCESS: 'UPDATE_INSTALLMENT_MODE_PAYLOAD_SUCCESS',
  UPDATE_INSTALLMENT_MODE_PAYLOAD_FAILED: 'UPDATE_INSTALLMENT_MODE_PAYLOAD_FAILED',

  ADD_INSTALLMENT_TENOR_PAYLOAD: 'ADD_INSTALLMENT_TENOR_PAYLOAD',
  ADDING_INSTALLMENT_TENOR_PAYLOAD: 'ADDING_INSTALLMENT_TENOR_PAYLOAD',
  ADD_INSTALLMENT_TENOR_PAYLOAD_SUCCESS: 'ADD_INSTALLMENT_TENOR_PAYLOAD_SUCCESS',
  ADD_INSTALLMENT_TENOR_PAYLOAD_FAILED: 'ADD_INSTALLMENT_TENOR_PAYLOAD_FAILED',

  UPDATE_INSTALLMENT_TENOR_PAYLOAD: 'UPDATE_INSTALLMENT_TENOR_PAYLOAD',
  UPDATING_INSTALLMENT_TENOR_PAYLOAD: 'UPDATING_INSTALLMENT_TENOR_PAYLOAD',
  UPDATE_INSTALLMENT_TENOR_PAYLOAD_SUCCESS: 'UPDATE_INSTALLMENT_TENOR_PAYLOAD_SUCCESS',
  UPDATE_INSTALLMENT_TENOR_PAYLOAD_FAILED: 'UPDATE_INSTALLMENT_TENOR_PAYLOAD_FAILED',

  ADD_SUB_CHANNEL_PAYLOAD: 'ADD_SUB_CHANNEL_PAYLOAD',
  ADDING_SUB_CHANNEL_PAYLOAD: 'ADDING_SUB_CHANNEL_PAYLOAD',
  ADD_SUB_CHANNEL_PAYLOAD_SUCCESS: 'ADD_SUB_CHANNEL_PAYLOAD_SUCCESS',
  ADD_SUB_CHANNEL_PAYLOAD_FAILED: 'ADD_SUB_CHANNEL_PAYLOAD_FAILED',

  FETCH_SUB_CHANNEL_PAYLOAD_BY_ID: 'FETCH_SUB_CHANNEL_PAYLOAD_BY_ID',
  FETCHING_SUB_CHANNEL_PAYLOAD_BY_ID: 'FETCHING_SUB_CHANNEL_PAYLOAD_BY_ID',
  FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_SUCCESS: 'FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_SUCCESS',
  FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_FAILED: 'FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_FAILED',
  RESET_SUB_CHANNEL_PAYLOAD_BY_ID: 'RESET_SUB_CHANNEL_PAYLOAD_BY_ID',

  UPDATE_SUB_CHANNEL_PAYLOAD: 'UPDATE_SUB_CHANNEL_PAYLOAD',
  UPDATING_SUB_CHANNEL_PAYLOAD: 'UPDATING_SUB_CHANNEL_PAYLOAD',
  UPDATE_SUB_CHANNEL_PAYLOAD_SUCCESS: 'UPDATE_SUB_CHANNEL_PAYLOAD_SUCCESS',
  UPDATE_SUB_CHANNEL_PAYLOAD_FAILED: 'UPDATE_SUB_CHANNEL_PAYLOAD_FAILED',

  ADD_PROCESSOR_PAYLOAD: 'ADD_PROCESSOR_PAYLOAD',
  ADDING_PROCESSOR_PAYLOAD: 'ADDING_PROCESSOR_PAYLOAD',
  ADD_PROCESSOR_PAYLOAD_SUCCESS: 'ADD_PROCESSOR_PAYLOAD_SUCCESS',
  ADD_PROCESSOR_PAYLOAD_FAILED: 'ADD_PROCESSOR_PAYLOAD_FAILED',

  UPDATE_PROCESSOR_PAYLOAD: 'UPDATE_PROCESSOR_PAYLOAD',
  UPDATING_PROCESSOR_PAYLOAD: 'UPDATING_PROCESSOR_PAYLOAD',
  UPDATE_PROCESSOR_PAYLOAD_SUCCESS: 'UPDATE_PROCESSOR_PAYLOAD_SUCCESS',
  UPDATE_PROCESSOR_PAYLOAD_FAILED: 'UPDATE_PROCESSOR_PAYLOAD_FAILED',

  ADD_MERCHANT_SPECIFIC_PAYLOAD: 'ADD_MERCHANT_SPECIFIC_PAYLOAD',
  ADDING_MERCHANT_SPECIFIC_PAYLOAD: 'ADDING_MERCHANT_SPECIFIC_PAYLOAD',
  ADD_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS: 'ADD_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS',
  ADD_MERCHANT_SPECIFIC_PAYLOAD_FAILED: 'ADD_MERCHANT_SPECIFIC_PAYLOAD_FAILED',

  FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID: 'FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID',
  FETCHING_MERCHANT_SPECIFIC_PAYLOAD_BY_ID: 'FETCHING_MERCHANT_SPECIFIC_PAYLOAD_BY_ID',
  FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_SUCCESS: 'FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_SUCCESS',
  FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_FAILED: 'FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_FAILED',
  RESET_MERCHANT_SPECIFIC_PAYLOAD_BY_ID: 'RESET_MERCHANT_SPECIFIC_PAYLOAD_BY_ID',

  UPDATE_MERCHANT_SPECIFIC_PAYLOAD: 'UPDATE_MERCHANT_SPECIFIC_PAYLOAD',
  UPDATING_MERCHANT_SPECIFIC_PAYLOAD: 'UPDATING_MERCHANT_SPECIFIC_PAYLOAD',
  UPDATE_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS: 'UPDATE_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS',
  UPDATE_MERCHANT_SPECIFIC_PAYLOAD_FAILED: 'UPDATE_MERCHANT_SPECIFIC_PAYLOAD_FAILED',

  FETCH_MERCHANT_SPECIFIC_PAYLOADS: 'FETCH_MERCHANT_SPECIFIC_PAYLOADS',
  FETCHING_MERCHANT_SPECIFIC_PAYLOADS: 'FETCHING_MERCHANT_SPECIFIC_PAYLOADS',
  FETCH_MERCHANT_SPECIFIC_PAYLOADS_SUCCESS: 'FETCH_MERCHANT_SPECIFIC_PAYLOADS_SUCCESS',
  FETCH_MERCHANT_SPECIFIC_PAYLOADS_FAILED: 'FETCH_MERCHANT_SPECIFIC_PAYLOADS_FAILED',

  FETCH_PAYMENT_CHANNEL_CONFIGURATIONS: 'FETCH_PAYMENT_CHANNEL_CONFIGURATIONS',
  FETCHING_PAYMENT_CHANNEL_CONFIGURATIONS: 'FETCHING_PAYMENT_CHANNEL_CONFIGURATIONS',
  FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_SUCCESS: 'FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_SUCCESS',
  FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_FAILED: 'FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_FAILED',

  ADD_INTEGRATION_MANAGEMENT: 'ADD_INTEGRATION_MANAGEMENT',
  ADDING_INTEGRATION_MANAGEMENT: 'ADDING_INTEGRATION_MANAGEMENT',
  ADD_INTEGRATION_MANAGEMENT_SUCCESS: 'ADD_INTEGRATION_MANAGEMENT_SUCCESS',
  ADD_INTEGRATION_MANAGEMENT_FAILED: 'ADD_INTEGRATION_MANAGEMENT_FAILED',

  FETCH_INTEGRATION_MANAGEMENT: 'FETCH_INTEGRATION_MANAGEMENT',
  FETCHING_INTEGRATION_MANAGEMENT: 'FETCHING_INTEGRATION_MANAGEMENT',
  FETCH_INTEGRATION_MANAGEMENT_SUCCESS: 'FETCH_INTEGRATION_MANAGEMENT_SUCCESS',
  FETCH_INTEGRATION_MANAGEMENT_FAILED: 'FETCH_INTEGRATION_MANAGEMENT_FAILED',

  FETCH_INTEGRATION_MANAGEMENT_BY_ID: 'FETCH_INTEGRATION_MANAGEMENT_BY_ID',
  FETCHING_INTEGRATION_MANAGEMENT_BY_ID: 'FETCHING_INTEGRATION_MANAGEMENT_BY_ID',
  FETCH_INTEGRATION_MANAGEMENT_BY_ID_SUCCESS: 'FETCH_INTEGRATION_MANAGEMENT_BY_ID_SUCCESS',
  FETCH_INTEGRATION_MANAGEMENT_BY_ID_FAILED: 'FETCH_INTEGRATION_MANAGEMENT_BY_ID_FAILED',
  RESET_INTEGRATION_MANAGEMENT_BY_ID: 'RESET_INTEGRATION_MANAGEMENT_BY_ID',

  GENERATE_NEW_API_KEY_DATA: 'GENERATE_NEW_API_KEY_DATA',
  GENERATING_NEW_API_KEY_DATA: 'GENERATING_NEW_API_KEY_DATA',
  GENERATE_NEW_API_KEY_DATA_SUCCESS: 'GENERATE_NEW_API_KEY_DATA_SUCCESS',
  GENERATE_NEW_API_KEY_DATA_FAILED: 'GENERATE_NEW_API_KEY_DATA_FAILED',

  REUPLOAD_BANK_TRX_DATA: 'REUPLOAD_BANK_TRX_DATA',
  REUPLOADING_BANK_TRX_DATA: 'REUPLOADING_BANK_TRX_DATA',
  REUPLOAD_BANK_TRX_DATA_SUCCESS: 'REUPLOAD_BANK_TRX_DATA_SUCCESS',
  REUPLOAD_BANK_TRX_DATA_FAILED: 'REUPLOAD_BANK_TRX_DATA_FAILED',

  FETCH_RECON_AUDIT_LOGS: 'FETCH_RECON_AUDIT_LOGS',
  FETCHING_RECON_AUDIT_LOGS: 'FETCHING_RECON_AUDIT_LOGS',
  FETCH_RECON_AUDIT_LOGS_SUCCESS: 'FETCH_RECON_AUDIT_LOGS_SUCCESS',
  FETCH_RECON_AUDIT_LOGS_FAILED: 'FETCH_RECON_AUDIT_LOGS_FAILED',

  LOAD_MORE_RECON_AUDIT_LOGS: 'LOAD_MORE_RECON_AUDIT_LOGS',
  LOADING_MORE_RECON_AUDIT_LOGS: 'LOADING_MORE_RECON_AUDIT_LOGS',
  LOAD_MORE_RECON_AUDIT_LOGS_SUCCESS: 'LOAD_MORE_RECON_AUDIT_LOGS_SUCCESS',
  LOAD_MORE_RECON_AUDIT_LOGS_FAILED: 'LOAD_MORE_RECON_AUDIT_LOGS_FAILED',

  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),
  fetchAllRoles: payload => ({
    type: actions.FETCH_ROLE_DATA,
    payload
  }),
  fetchAllOTPServices: payload => ({
    type: actions.FETCH_OTP_SERVICE_DATA,
    payload
  }),
  setIsResetOTPServiceActiveData: payload => ({
    type: actions.SET_IS_RESET_OTP_SERVICE_ACTIVE_DATA,
    payload
  }),
  fetchOTPServicesTemplate: payload => ({
    type: actions.FETCH_OTP_SERVICE_TEMPLATE_DATA,
    payload
  }),
  fetchAllOTPIntegrators: payload => ({
    type: actions.FETCH_OTP_INTEGRATORS,
    payload
  }),
  fetchAllOTPLogs: (payload) => ({
    type: actions.FETCH_OTP_LOGS,
    payload
  }),
  fetchAllOTPLogsActionCount: payload => ({
    type: actions.FETCH_OTP_LOGS_ACTION_COUNT,
    payload
  }),
  setActiveOTPservice: otpService => ({
    type: actions.SET_ACTIVE_OTP_SERVICE,
    otpService
  }),
  fetchAllModules: payload => ({
    type: actions.FETCH_MODULE_DATA,
    payload
  }),
  fetchAllIndustries: payload => ({
    type: actions.FETCH_INDUSTRY_DATA,
    payload
  }),
  fetchAllAddresses: payload => ({
    type: actions.FETCH_ADDRESSES_DATA,
    payload
  }),
  addNewRole: payload => ({
    type: actions.ADD_ROLE_DATA,
    payload
  }),
  addNewModule: payload => ({
    type: actions.ADD_MODULE_DATA,
    payload
  }),
  addNewLookups: payload => ({
    type: actions.ADD_LOOKUPS_DATA,
    payload
  }),
  editRoleData: (payload, id, modules) => ({
    type: actions.EDIT_ROLE_DATA,
    payload,
    id,
    modules
  }),
  fetchRoleByID: payload => ({
    type: actions.FETCH_ROLE_DATA_BY_ID,
    payload
  }),
  fetchUserActivity: (payload) => ({
    type: actions.FETCH_USER_SYSTEM_LOGS,
    payload
  }),
  resetUserActivity: () => ({
    type: actions.RESET_USER_SYSTEM_LOGS
  }),
  fetchAllUsers: (payload) => ({
    type: actions.FETCH_USER_DATA,
    payload
  }),
  fetchAllLookups: payload => ({
    type: actions.FETCH_LOOKUPS_DATA,
    payload
  }),
  addNewUser: payload => ({
    type: actions.ADD_USER_DATA,
    payload
  }),
  inviteNewUser: payload => ({
    type: actions.INVITE_USER_DATA,
    payload
  }),
  resendInviteNewUser: payload => ({
    type: actions.RESEND_INVITE_USER_DATA,
    payload
  }),
  fetchInvitedUserDetails: payload => ({
    type: actions.FETCH_INVITED_USER_DATA,
    payload
  }),
  logAccessInvite: id => ({
    type: actions.LOG_ACCESS_INVITE_DATA,
    id
  }),
  fetchAllInvitedUsersData: payload => ({
    type: actions.FETCH_ALL_INVITED_USERS_DATA,
    payload
  }),
  signUp: payload => ({
    type: actions.SIGN_UP_USER_DATA,
    payload
  }),
  editLookups: (payload, id) => ({
    type: actions.EDIT_LOOKUPS_DATA,
    payload,
    id
  }),
  editSystemStatus: (payload, id) => ({
    type: actions.EDIT_SYSTEM_MODULE_STATUS,
    payload,
    id
  }),
  editLookupGroup: (payload, id) => ({
    type: actions.EDIT_LOOKUP_GROUP_DATA,
    payload,
    id
  }),
  addNewIndustry: payload => ({
    type: actions.ADD_INDUSTRY_DATA,
    payload
  }),
  editIndustry: (payload, id) => ({
    type: actions.EDIT_INDUSTRY_DATA,
    payload,
    id
  }),
  addNewPaymentChannel: payload => ({
    type: actions.ADD_PAYMENT_CHANNEL_DATA,
    payload
  }),
  addNewAddress: payload => ({
    type: actions.ADD_ADDRESS_DATA,
    payload
  }),
  addNewOtpService: payload => ({
    type: actions.ADD_OTP_SERVICE_DATA,
    payload
  }),
  addNewOtpServiceTemplate: payload => ({
    type: actions.ADD_OTP_SERVICE_TEMPLATE_DATA,
    payload
  }),
  testGenerateOTP: (payload, header) => ({
    type: actions.TEST_GENERATE_OTP,
    payload,
    header
  }),
  resetTestGenerateOTP: () => ({
    type: actions.RESET_TEST_GENERATE_OTP
  }),
  addNewProvince: payload => ({
    type: actions.ADD_PROVINCE_DATA,
    payload
  }),
  defineKeyCities: payload => ({
    type: actions.DEFINE_KEY_CITIES,
    payload
  }),
  deleteLookup: payload => ({
    type: actions.DELETE_LOOKUP_DATA,
    payload
  }),
  editAddress: (payload, id) => ({
    type: actions.EDIT_ADDRESS_DATA,
    payload,
    id
  }),
  editOTPConfig: (payload, id) => ({
    type: actions.EDIT_OTP_SETTINGS_DATA,
    payload,
    id
  }),
  editOTPConfigTemplate: (payload, id) => ({
    type: actions.EDIT_OTP_SETTINGS_TEMPLATE_DATA,
    payload,
    id
  }),
  generateNewOtpToken: (payload, id) => ({
    type: actions.GENERATE_NEW_OTP_KEY_DATA,
    payload,
    id
  }),
  changeAddressStatus: (payload, id) => ({
    type: actions.CHANGE_STATUS_ADDRESS_DATA,
    payload,
    id
  }),
  changeIndustryStatus: (payload, id) => ({
    type: actions.CHANGE_STATUS_INDUSTRY_DATA,
    payload,
    id
  }),
  deleteRole: payload => ({
    type: actions.DELETE_ROLE_DATA,
    payload
  }),
  deleteUser: payload => ({
    type: actions.DELETE_USER_DATA,
    payload
  }),
  editUser: (payload, id) => ({
    type: actions.EDIT_USER_DATA,
    payload,
    id
  }),

  resetUserPassword: (payload, id) => ({
    type: actions.RESET_USER_PASSWORD,
    payload,
    id
  }),
  unlockUser: (payload, id) => ({
    type: actions.UNLOCK_USER_ACCOUNT,
    payload,
    id
  }),
  lockUser: (payload, id) => ({
    type: actions.LOCK_USER,
    payload: { payload, id }
  }),
  changeUserStatus: (payload, id) => ({
    type: actions.CHANGE_USER_STATUS,
    payload,
    id
  }),
  resetLookupsData: () => ({
    type: actions.RESET_LOOKUPS_DATA
  }),
  fetchPaymentChannels: payload => ({
    type: actions.FETCH_PCHANNEL_DATA,
    payload
  }),
  fetchPaymentChannelList: payload => ({
    type: actions.FETCH_PAYMENT_CHANNEL_LIST_DATA,
    payload
  }),
  fetchPaymentMethodList: payload => ({
    type: actions.FETCH_PAYMENT_METHOD_LIST_DATA,
    payload
  }),
  fetchNotificationData: payload => ({
    type: actions.FETCH_NOTIFICATION_DATA,
    payload
  }),
  addNotificationData: payload => ({
    type: actions.ADD_NOTIFICATION_DATA,
    payload
  }),

  updateAppNotification: (payload, id) => ({
    type: actions.UPDATE_APP_NOTIFICATION,
    payload,
    id
  }),
  resetUpdateAppNotification: () => ({
    type: actions.RESET_UPDATE_APP_NOTIFICATION
  }),
  getUserListByRoleID: payload => ({
    type: actions.GET_USER_LIST_BY_ROLE,
    payload
  }),
  fetchUsers: payload => ({
    type: actions.FETCH_USERS,
    payload
  }),
  reorderLookup: payload => ({
    type: actions.REORDER_LOOKUP_DATA,
    payload
  }),
  reorderPage: payload => ({
    type: actions.REORDER_PAGE_DATA,
    payload
  }),
  reorderModule: payload => ({
    type: actions.REORDER_MODULE_DATA,
    payload
  }),
  fetchExternalRecipients: payload => ({
    type: actions.FETCH_EXTERNAL_RECIPIENTS_DATA,
    payload
  }),
  editExternalRecipient: (payload, id) => ({
    type: actions.EDIT_EXTERNAL_RECIPIENT_DATA,
    payload,
    id
  }),
  fetchLookupValidation: payload => ({
    type: actions.FETCH_LOOKUP_VALIDATION_DATA,
    payload
  }),
  setLookupValidationData: (payload, id) => ({
    type: actions.SET_LOOKUP_VALIDATION_DATA,
    payload,
    id
  }),
  editLookupValidation: (payload, id) => ({
    type: actions.EDIT_LOOKUP_VALIDATION_DATA,
    payload,
    id
  }),
  deleteLookupValidation: payload => ({
    type: actions.DELETE_LOOKUP_VALIDATION_DATA,
    payload
  }),
  fetchAllTemplateData: payload => ({
    type: actions.FETCH_TEMPLATE_DATA,
    payload
  }),
  resetTemplateData: payload => ({
    type: actions.RESET_TEMPLATE_DATA,
    payload
  }),

  fetchAllBankTemplateData: payload => ({
    type: actions.FETCH_BANK_TEMPLATE_DATA,
    payload
  }),
  addNewTemplate: payload => ({
    type: actions.ADD_TEMPLATE_DATA,
    payload
  }),
  addNewBankTemplate: (payload, id) => ({
    type: actions.ADD_BANK_TEMPLATE_DATA,
    payload,
    id
  }),
  editTemplateData: (payload, id) => ({
    type: actions.EDIT_TEMPLATE_DATA,
    payload,
    id
  }),
  fetchAllUploadedFiles: (payload) => ({
    type: actions.FETCH_UPLOADED_FILES,
    payload
  }),
  uploadFileData: (url, payload, pagination) => ({
    type: actions.UPLOAD_FILE_TRANSACTION_DATA,
    url,
    payload,
    pagination
  }),
  uploadFileBankTrxData: (url, payload, pagination) => ({
    type: actions.UPLOAD_BANK_TRX_DATA,
    url,
    payload,
    pagination
  }),
  uploadMultipleFileData: (urls, payload, pagination) => ({
    type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA,
    urls,
    payload,
    pagination
  }),
  uploadLeadsFileData: (urls, payload) => ({
    type: actions.UPLOAD_LEADS_FILE_DATA,
    urls,
    payload
  }),
  reuploadLeadsFileData: (urls, payload) => ({
    type: actions.REUPLOAD_LEADS_FILE_DATA,
    urls,
    payload
  }),
  reuploadFileData: (url, payload, pagination) => ({
    type: actions.REUPLOAD_FILE_TRANSACTION_DATA,
    url,
    payload,
    pagination
  }),
  getPreSignedURL: filename => ({
    type: actions.GET_PRE_SIGNED_URL,
    filename
  }),
  getPresignedURLWithKey: filename => ({
    type: actions.GET_PRE_SIGNED_URL_WITH_KEY,
    filename
  }),
  fetchAllCosmosLogs: (payload) => ({
    type: actions.FETCH_COSMOS_LOGS,
    payload
  }),
  setPaymentChannelFilter: payload => ({
    type: actions.SET_PAYMENT_CHANNEL_FILTER,
    payload
  }),
  getMultiplePresignedURL: files => ({
    type: actions.GET_LIST_OF_PRE_SIGNED_URL,
    files
  }),
  fetchAllSystemSettings: () => ({
    type: actions.FETCH_SYSTEM_SETTINGS
  }),
  addSystemSettings: payload => ({
    type: actions.ADD_SYSTEM_SETTINGS,
    payload
  }),
  editSystemSettings: payload => ({
    type: actions.EDIT_SYSTEM_SETTINGS,
    payload
  }),
  fetchLogsByItemId: (id, payload) => ({
    type: actions.FETCH_LOGS_BY_ITEM_ID,
    id,
    payload
  }),
  editTemplateBankDetails: (payload, id, code) => ({
    type: actions.EDIT_PAYNAMICS_BANK_TEMPLATE_DATA,
    payload,
    id,
    code
  }),
  fetchPaynamicsBankData: payload => ({
    type: actions.FETCH_PAYNAMICS_BANK_DATA,
    payload
  }),
  addPaynamicsBank: payload => ({
    type: actions.ADD_PAYNAMICS_BANK,
    payload
  }),
  editPaynamicsBank: (id, payload) => ({
    type: actions.EDIT_PAYNAMICS_BANK,
    id,
    payload
  }),
  addNewPageAction: payload => ({
    type: actions.ADD_PAGE_ACTION,
    payload
  }),
  editPageAction: (payload, id) => ({
    type: actions.EDIT_PAGE_ACTION,
    payload,
    id
  }),
  resetModuleData: () => ({
    type: actions.RESET_MODULE_DATA
  }),
  editPaymentChannel: (payload, id) => ({
    type: actions.EDIT_PAYMENT_CHANNEL_DATA,
    payload,
    id
  }),
  fetchAllUserDeptData: () => ({
    type: actions.FETCH_ALL_USER_DEPT_DATA
  }),
  editNotifSettings: (payload, id) => ({
    type: actions.EDIT_NOTIFICATION_SETTING,
    payload,
    id
  }),
  fetchLookupsDataRevamped: () => ({
    type: actions.FETCH_LOOKUPS_DATA_REVAMPED
  }),
  setLookupsEdited: edited => ({
    type: actions.EDITED_LOOKUPS_DATA,
    edited
  }),

  addPaymentChannelPayload: (payload, id) => ({
    type: actions.ADD_PAYMENT_CHANNEL_PAYLOAD,
    payload,
    id
  }),

  fetchPaymentChannelPayloadById: payload => ({
    type: actions.FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID,
    payload
  }),

  updatePaymentChannelPayload: (payload, id) => ({
    type: actions.UPDATE_PAYMENT_CHANNEL_PAYLOAD,
    payload,
    id
  }),

  resetPaymentChannelPayloadById: () => ({
    type: actions.RESET_PAYMENT_CHANNEL_PAYLOAD_BY_ID
  }),

  addInstallmentModePayload: (payload, id) => ({
    type: actions.ADD_INSTALLMENT_MODE_PAYLOAD,
    payload,
    id
  }),

  fetchInstallmentModePayloadById: payload => ({
    type: actions.FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID,
    payload
  }),

  updateInstallmentModePayload: (payload, id) => ({
    type: actions.UPDATE_INSTALLMENT_MODE_PAYLOAD,
    payload,
    id
  }),

  resetInstallmentModePayloadById: () => ({
    type: actions.RESET_INSTALLMENT_MODE_PAYLOAD_BY_ID
  }),

  addInstallmentTenorPayload: (payload, id) => ({
    type: actions.ADD_INSTALLMENT_TENOR_PAYLOAD,
    payload,
    id
  }),

  updateInstallmentTenorPayload: (payload, id) => ({
    type: actions.UPDATE_INSTALLMENT_TENOR_PAYLOAD,
    payload,
    id
  }),

  addSubChannelPayload: (payload, id) => ({
    type: actions.ADD_SUB_CHANNEL_PAYLOAD,
    payload,
    id
  }),

  fetchSubChannelPayloadById: payload => ({
    type: actions.FETCH_SUB_CHANNEL_PAYLOAD_BY_ID,
    payload
  }),

  updateSubChannelPayload: (payload, id) => ({
    type: actions.UPDATE_SUB_CHANNEL_PAYLOAD,
    payload,
    id
  }),

  resetSubChannelPayloadById: () => ({
    type: actions.RESET_SUB_CHANNEL_PAYLOAD_BY_ID
  }),

  addProcessorPayload: (payload, id) => ({
    type: actions.ADD_PROCESSOR_PAYLOAD,
    payload,
    id
  }),

  updateProcessorPayload: (payload, id) => ({
    type: actions.UPDATE_PROCESSOR_PAYLOAD,
    payload,
    id
  }),

  addMerchantSpecificPayload: (payload, id) => ({
    type: actions.ADD_MERCHANT_SPECIFIC_PAYLOAD,
    payload,
    id
  }),

  fetchMerchantSpecificPayloadById: payload => ({
    type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID,
    payload
  }),

  updateMerchantSpecificPayload: (payload, id) => ({
    type: actions.UPDATE_MERCHANT_SPECIFIC_PAYLOAD,
    payload,
    id
  }),

  resetMerchantSpecificPayloadById: () => ({
    type: actions.RESET_MERCHANT_SPECIFIC_PAYLOAD_BY_ID
  }),

  fetchMerchantSpecificPayloads: () => ({
    type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOADS
  }),

  fetchPaymentChannelConfigurations: () => ({
    type: actions.FETCH_PAYMENT_CHANNEL_CONFIGURATIONS
  }),

  addIntegrationManagement: payload => ({
    type: actions.ADD_INTEGRATION_MANAGEMENT,
    payload
  }),

  fetchIntegrationManagement: (payload) => ({
    type: actions.FETCH_INTEGRATION_MANAGEMENT,
    payload
  }),

  fetchIntegrationManagementById: payload => ({
    type: actions.FETCH_INTEGRATION_MANAGEMENT_BY_ID,
    payload
  }),

  resetIntegrationManagementById: () => ({
    type: actions.RESET_INTEGRATION_MANAGEMENT_BY_ID
  }),

  generateNewAPIKey: (payload, id) => ({
    type: actions.GENERATE_NEW_API_KEY_DATA,
    payload,
    id
  }),

  reuploadBankTrxData: (url, payload, pagination) => ({
    type: actions.REUPLOAD_BANK_TRX_DATA,
    url,
    payload,
    pagination
  }),

  fetchReconAuditLogs: (payload, pagination) => ({
    type: actions.FETCH_RECON_AUDIT_LOGS,
    payload,
    pagination
  }),

  loadMoreReconAuditLogs: (payload, pagination) => ({
    type: actions.LOAD_MORE_RECON_AUDIT_LOGS,
    payload,
    pagination
  })
};
export default actions;
